import { apiurl } from '@/services/config'
const API_URL = apiurl + '/backoffice/'

export const NewsService = {
  NewsList,
  AddNews,
  EditNews,
  deleteNews
}

async function NewsList () {
  return fetch(API_URL + 'news', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function deleteNews (newsid) {
  return fetch(API_URL + 'news/' + newsid, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function AddNews (postdata) {
  return fetch(API_URL + 'news', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function EditNews (postdata) {
  return fetch(API_URL + 'news', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }
      const error = (data && data.msg) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
